import tailwindConfig from 'tailwind-config';

export function useTailwindTheme() {
  return tailwindConfig.theme;
}
